var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GoodSelect',{on:{"on-change":_vm.onChange}}),_c('Table',{staticStyle:{"margin-top":"10px"},attrs:{"border":"","columns":_vm.columns1,"data":_vm.data1},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Button',{on:{"click":function($event){return _vm.remove(index)}}},[_vm._v("删除")])]}}])}),_c('Button',{staticStyle:{"margin-top":"10px"},on:{"click":_vm.save}},[_vm._v("保存")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }